// material-ui
import { Box, Container, Grid, Rating, Typography } from "@mui/material";

// third party
import Slider from "react-slick";

// project import
import Avatar from "../../components/@extended/Avatar";
import MainCard from "../../components/MainCard";

// assets
import imgfeature1 from "../../assets/images/landing/img-user1.svg";
import { display } from "@mui/system";

// ================================|| TESTIMONIAL - ITEMS ||================================ //

interface Props {
  item: {
    image: string;
    title: string;
    review: string;
    rating: number;
    client: string;
  };
}

const Item = ({ item }: Props) => (
  <MainCard sx={{ mx: 2 }} contentSX={{ p: 3 }}>
    <Grid container spacing={1}>
      <Grid item>
        <Avatar src={item.image} alt="feature" />
      </Grid>
      <Grid item sm zeroMinWidth>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Typography variant="h5" sx={{ fontWeight: 600 }}>
              {item.client}
            </Typography>
            <Rating
              name="read-only"
              readOnly
              value={item.rating}
              size="small"
              precision={0.5}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6" color="#8c8c8c">
              {item.review}
            </Typography>
          </Grid>
          {/* <Grid item xs={12}>
            <Typography variant="subtitle2">{item.client}</Typography>
          </Grid> */}
        </Grid>
      </Grid>
    </Grid>
  </MainCard>
);

// ==============================|| LANDING - TESTIMONIAL PAGE ||============================== //

const TestimonialBlock = () => {
  const settings = {
    autoplay: true,
    arrows: false,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const items = [
    {
      image: imgfeature1,
      title: "Qualidade da assinatura",
      review:
        "Boa tarde. Com a facilidade de todo mecanismo. E a rapidez. Que vcs continue assim que estarei sempre com vcs.. Muito obrigada e fico no aguardo. Um grande abraço.",
      rating: 5,
      client: "Marta S.",
    },
    {
      image: imgfeature1,
      title: "Qualidade da assinatura",
      review:
        "Foi simples, objetivo e rápido! As vzs temos dificuldades, por conta da claridade e da internet ruim! Parabéns! Um dos . melhores de se operar!",
      rating: 5,
      client: "Lauro M.",
    },
    {
      image: imgfeature1,
      title: "Qualidade da assinatura",
      review:
        "Conforme informei no questionamento anterior: para mim, a rapidez para preencher os ítens solicitados foram indefectíveis... Simples assim!!!",
      rating: 5,
      client: "Carlos D.",
    },
    {
      image: imgfeature1,
      title: "Qualidade da assinatura",
      review:
        "Boa tarde Rápido eficiente Muito bom está forma sem precisas sair de casa. Vcs passam confiança e credibilidade. Obrigada. Fiquem bem.",
      rating: 5,
      client: "Simone L.",
    },
    {
      image: imgfeature1,
      title: "Qualidade da assinatura",
      review:
        "Gostei da ausência de burocracia, tudo muito rápido, objetivo e simples.",
      rating: 5,
      client: "Marilene A.",
    },
    {
      image: imgfeature1,
      title: "Qualidade da assinatura",
      review:
        "Tudo muito simples, fácil  e bem divertido. Gostei muito do sistema.Deus seja Louvado!",
      rating: 5,
      client: "Margarete S.",
    },
    {
      image: imgfeature1,
      title: "Qualidade da assinatura",
      review: "Praticidade, não precisa assinar aquele monte de papel.",
      rating: 5,
      client: "Alonso P.",
    },
  ];

  return (
    <Box sx={{ overflowX: "hidden" }}>
      <Container>
        <Grid
          container
          alignItems="center"
          justifyContent="center"
          spacing={2}
          sx={{ mt: { md: 15, xs: 2.5 }, mb: { md: 10, xs: 2.5 } }}
        >
          <Grid item xs={12}>
            <Grid
              container
              spacing={1}
              justifyContent="center"
              sx={{ mb: 4, textAlign: "center" }}
            >
              <Grid item sm={10} md={6}>
                <Grid container spacing={1} justifyContent="center">
                  {/* <Grid item xs={12}>
                    <Typography variant="subtitle1" color="primary">
                      Testament
                    </Typography>
                  </Grid> */}
                  <Grid item xs={12}>
                    <Typography variant="h2">O Que Dizem Sobre Nós</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="h5">
                      Depoimentos de clientes satisfeitos com nossa solução
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            lg={6}
            md={8}
            xs={12}
            sx={{
              "& .slick-list": { overflow: "visible" },
              "& .slick-track": { display: "flex" },
            }}
          >
            <Slider {...settings}>
              {items.map((item, index) => (
                <Item key={index} item={item} />
              ))}
            </Slider>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default TestimonialBlock;
